import React from 'react';
import { Fade } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import { POPUP_TYPE, FadeInAndOutDuration, HeadingColor } from './constant';
import './styles.css';

export const Popup = ({
  open = false,
  title,
  children: content,
  type = POPUP_TYPE.INFO,
  onClose: handleClose = () => {},
}) => (
  <Fade in={open} timeout={FadeInAndOutDuration}>
    <div className={`popup-container-v2 popup-container-v2-${type} flex flex-fill bg-white align-items-flex-start justify-content-center`}>
      <div className='flex flex-column flex-fill p-5 gap-12'>
        <div className='popup-heading flex align-items-center'>
          <p className={`font-16 bold font-roboto m-0 ${HeadingColor.get(type)}`}>{title}</p>
        </div>
        <div className='popup-content'>{content}</div>
      </div>

      <IconButton aria-label="close" onClick={handleClose}>
        <CloseIcon />
      </IconButton>
    </div>
  </Fade>
);

export default Popup;
